export default "__VITE_ASSET__DydcrQQP__"